 

export const state = {
    isResetPassModalOpen: false,

    emailToReset: false,


    isConfirmationModalOpen: false,

    interested: null,

    userUuid: null,

    vacancyId: null,
}

export const getters = {
    isResetPassModalOpen: state => state.isResetPassModalOpen,

    emailToReset: state => state.emailToReset,


    isConfirmationModalOpen: state => state.isConfirmationModalOpen,

    interested: state => state.interested,

    userUuid: state => state.userUuid,

    vacancyId: state => state.vacancyId,
}

export const mutations = {
    openResetPassModal(state) {
        state.isResetPassModalOpen = true;
    },
    
    closeResetPassModal(state) {
        state.isResetPassModalOpen = false;
    },

    setEmailToReset(state, value) {
        state.emailToReset = value;
    },


    openConfirmationModal(state) {
        state.isConfirmationModalOpen = true;
    },
    
    closeConfirmationModal(state) {
        state.isConfirmationModalOpen = false;
    },

    setInterested(state, value) {
        state.interested = value;
    },

    setUserUuid(state, value) {
        state.userUuid = value;
    },

    setVacancyId(state, value) {
        state.vacancyId = value;
    },

}

export const actions = {
    toggleResetPassModal({ commit }, open) { 
        if (open) {
            commit('openResetPassModal');
        } else {
            commit('closeResetPassModal');
        }
    },

    setEmailToResetVal({ commit }, email){
        commit('setEmailToReset', email);
    },


    toggleConfirmationModal({ commit }, open) { 
        if (open) {
            commit('openConfirmationModal');
        } else {
            commit('closeConfirmationModal');
        }
    },

    toggleInterested({ commit }, isInterested) { 
        commit('setInterested', isInterested);
    },

    resetInterested({ commit }) {  
        commit('setInterested', null);
    },


    setUserUuidValue({ commit }, uuid){
        commit('setUserUuid', uuid);
    },

    setVacancyIdValue({ commit }, vacancyId){
        commit('setVacancyId', vacancyId);
    }
}

export default {
  namespaced: true,  
  state,
  getters,
  mutations,
  actions,
};